<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div id="page-log-list" class="ag-grid-container">

    <div class="vx-card">
      <grid-action-bar
          :show-deleted="false"
          v-on:update:search="searchQuery = $event"
          title="Role Sync"
      >
        <template slot="right">
          <div class="mr-4">
            <ul>
              <li><strong>Total:</strong> {{data.length}}</li>
            </ul>
          </div>
          <div>
            <ul>
              <li><strong>Mismatched values:</strong> {{mismatched.length}}</li>
              <li><strong>Missing in CMI:</strong> {{cmiMissing.length}}</li>
              <li><strong>Missing in Auth0:</strong> {{externalMissing.length}}</li>
            </ul>
          </div>
        </template>
      </grid-action-bar>

      <!-- AgGrid Table -->
      <t-grid
          :column-defs="columnDefs"
          class="lg"
          :data="data"
          :loading="loading"
          :search="searchQuery"
          auto-size
      />
    </div>
  </div>

</template>

<script>


// Cell Renderer
import TGrid from "@/views/components/ag-grid/TGrid";
import GridActionBar from "@/views/components/extra-components/GridActionBar";
import CellMatchingMixin from "@/views/pages/sync/CellMatchingMixin";

export default {
  components: {
    TGrid,
    GridActionBar,
  },
  mixins: [CellMatchingMixin],
  data () {
    return {


      searchQuery: '',
      showDeleted: false,

      // AgGrid
      columnDefs: [
        {
          headerName: 'ID',
          field: 'Role_PK',
          filter: 'agTextColumnFilter',
          width: 310,
          maxWidth: 350,
          sortable: true,
          sort: 'desc',
        },
        {
          headerName: 'Application',
          field: 'application.ApplicationName',
          filter: 'agTextColumnFilter',
          width: 300,
        },
        {
          headerName: 'Role Name',
          field: 'RoleName',
          filter: 'agTextColumnFilter',
          width: 300,
          cellClass: (params, match = params.data.ExternalIdentity.name) =>
              this.matchingCellStyle(params, match)
        },
        {
          headerName: 'Role Description',
          field: 'RoleDescription',
          filter: 'agTextColumnFilter',
          width: 300,
          cellClass: (params, match = params.data.ExternalIdentity.description) =>
              this.matchingCellStyle(params, match)
        },
        {
          headerName: 'SSO - Role Name',
          field: 'ExternalIdentity.name',
          filter: 'agTextColumnFilter',
          width: 200,
          cellClass: (params, match = params.data.RoleName) =>
              this.matchingCellStyle(params, match)
        },
        {
          headerName: 'SSO - Role Description',
          field: 'ExternalIdentity.description',
          filter: 'agTextColumnFilter',
          width: 200,
          cellClass: (params, match = params.data.RoleDescription) =>
              this.matchingCellStyle(params, match)
        },
      ],
      // Cell Renderer Components
      data: [],
      loading: false,
    }
  },
  computed: {
    mismatched() {
      return this.data.filter(({HasFalseMatch}) => HasFalseMatch);
    },
    cmiMissing() {
      return this.data.filter(({Role_PK}) => !Role_PK);
    },
    externalMissing() {
      return this.data.filter(({ExternalIdentity}) => !ExternalIdentity);
    }
  },
  mounted() {
    this.list();
  },
  methods: {
    async list(params = {}) {
      try {
        this.loading = true;
        const { data } = await this.$api.sync.roles.list();
        this.allRows = data.data;
        this.data = this.allRows
            //.filter(({HasFalseMatch}) => HasFalseMatch);
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
  },
}

</script>

<style lang="scss">
</style>
